/** Max seconds past a checkpoint timestamp that still counts as a trigger (guards against seek jumps). */
export const CHECKPOINT_TRIGGER_TOLERANCE = 0.3;
